export type Stages = 'draft' | 'qc_check' | 'review' | 'outcome';

export type EntityType = 'site' | 'study';

export type EntityTypeExtend = EntityType | 'workspace';

export const STAGES_AFTER_QC = new Set<Stages>(['review', 'outcome']);

export const SUBMISSSION_DETAILS_V2_PATH = 'v2/submissions';

export const SUBMISSION_UPDATE_NO_RESPONSE_MESSAGE =
  "Something interrupted that action and it wasn't completed. Please try again in a moment. If the problem continues, contact your administrator.";
